import { useHandleHttpError as useSharedHandleHttpError } from '@easylife365/react';

// The App's own codes are translated from `common`, the platform's from `core`.
const options = { namespaces: ['common', 'core'], showRequestId: true };

/** `@easylife365/react`'s handler, told where the App keeps the translations of the codes it owns. */
export default function useHandleHttpError() {
  return useSharedHandleHttpError(options);
}
